import { SectionConstants as Constants } from '../types'

const initialState = {
    sections: [],    
    error: null,    
    loading: false   
};

export function sectionReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:                     
            return {
                ...state,
                sections: action?.payload?.sections,
                loading: false,
                error: null,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                sections: [...state?.sections, action?.payload?.section],
                loading: false,
                error: null,
            }

        case Constants.UPDATE:            
            const index = state.sections.findIndex(x => x.id ===  action?.payload?.section?.id)
            const newArray = [...state.sections];
            if(index > -1)
                newArray[index] = action?.payload?.section
            return {
                ...state,
                sections: newArray,
                loading: false,
                error: null,
            }   

        case Constants.DELETE:
            return{
                ...state,
                sections: state?.sections?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id)),
                loading: false,
                error: null,
            };

        
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error,
                loading: false
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null,
                loading: true
            }

        case Constants.CLEAR:
        default:
            return state
    }
}